import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Popup, Table } from 'semantic-ui-react';

import { Fecha, NombrePersonal } from 'src/componentes';
import { ResumenMatricula } from 'src/modulos/Matriculas/comun/tipos';
import EtiquetaDeEstadoAprobacion from './EtiquetaDeEstadoAprobacion';

type FormasPago = 'contado' | 'tarjeta' | 'pagare' | 'cheque';

const nombresFormasPago: Record<FormasPago, string> = {
    contado: 'Contado',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    pagare: 'Pagaré',
};

export const CabeceraAsesor = () => {
    return (
        <Table.Row>
            <Table.HeaderCell>Números de contrato</Table.HeaderCell>
            <Table.HeaderCell>Hecha por</Table.HeaderCell>
            <Table.HeaderCell>Promotor</Table.HeaderCell>
            <Table.HeaderCell>Número de pagaré</Table.HeaderCell>
            <Table.HeaderCell>Forma de pago</Table.HeaderCell>
            <Table.HeaderCell>Fecha</Table.HeaderCell>
            <Table.HeaderCell width='1'>Estado</Table.HeaderCell>
        </Table.Row>
    );
};

export const FilaAsesor: React.FC<ResumenMatricula> = props => {
    const {
        id,
        responsable,
        promotor,
        numerosDeContrato,
        numeroDePagare,
        formaDePago,
        fecha,
        estadoAprobacion,
        estadoVerificacion,
        nulo,
    } = props;

    return (
        <Table.Row>
            <Table.Cell selectable>
                <Link to={'matriculas/' + id.toString()}>
                    <b>{numerosDeContrato.join(', ')}</b>
                </Link>
            </Table.Cell>
            <Table.Cell content={<NombrePersonal nombre={responsable} patron='%N %P' />} />
            <Table.Cell content={promotor} />
            <Table.Cell content={numeroDePagare} />
            <Table.Cell content={nombresFormasPago[formaDePago]} />
            <Table.Cell content={<Fecha fecha={fecha} />} />
            <Table.Cell singleLine width='1'>
                <EtiquetaDeEstadoAprobacion nulo={nulo} estadoAprobacion={estadoAprobacion} />
                <Popup
                    open={estadoVerificacion.estado !== 'pendiente' ? false : undefined}
                    trigger={
                        estadoVerificacion.estado === 'pendiente' && (
                            <Icon name='times' color='black' />
                        )
                    }
                >
                    <Popup.Header />
                    {estadoVerificacion.estado === 'pendiente' && (
                        <Popup.Content>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneFirmas && 'Falta firma'}
                            </p>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneFotocopias && 'Falta fotocopia'}
                            </p>
                            <p style={{ whiteSpace: 'pre-line' }}>
                                {!estadoVerificacion.tieneHuellas && 'Falta huella'}
                            </p>
                        </Popup.Content>
                    )}
                </Popup>
                {estadoVerificacion.estado === 'verificada' && <Icon name='check' color='green' />}
            </Table.Cell>
        </Table.Row>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/ListaDeProcesos/TablaDeProcesos/FilaAsesor.tsx